import queryString from 'query-string';
export interface AuthQueryParams {
  state: string;
  code: string;
  redirect: string;
  accessToken: string;
  refreshToken: string;
}

export const getAuthQueryParams = (): Partial<AuthQueryParams> =>
  queryString.parse(location.search);
